/* eslint-disable import/prefer-default-export */
import { Box, Tooltip } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { GridColDef } from "@mui/x-data-grid";
import { AuditColumnSummary } from "./audit-types";
import { formatAuditCellValue, isDateLikeValue } from "./audit-utils";
import CopyableText from "../copyable-text/copyable-text";

const isEmptyValue = (value: unknown) =>
  value === null || value === undefined || value === "";

export const getAuditColumns = (
  columns: AuditColumnSummary[],
  includeSensitive: boolean,
  dateRangeColumn: string | null,
): GridColDef[] =>
  columns
    .filter((column) => !column.isSensitive || includeSensitive)
    .map((column) => {
      const isDateColumn = column.columnName === dateRangeColumn;

      return {
        field: column.columnName,
        headerName: column.displayName,
        sortable: column.isSortable,
        flex: 1,
        minWidth: 140,
        renderHeader: () => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <span>{column.displayName}</span>
            {column.isSensitive && (
              <Tooltip title="Sensitive column">
                <LockOutlinedIcon
                  sx={{ fontSize: 14, color: "warning.main" }}
                />
              </Tooltip>
            )}
          </Box>
        ),
        renderCell: (params) => {
          const text = formatAuditCellValue(
            params.value,
            isDateColumn || isDateLikeValue(params.value),
          );

          return isEmptyValue(params.value) ? (
            <span>{text}</span>
          ) : (
            <CopyableText text={text} />
          );
        },
      };
    });
